module.exports = __webpack_public_path__ + "img/hr-myLearningPath.e6908d7c.png";